import { MappingItem } from '../../GTM'

export const productClick = (): MappingItem => {
    return {
        id: ['id'],
        name: ['name'],
        sku: ['sku'],
        price: ['price_range', 'minimum_price', 'final_price', 'value'],
        currency_code: [
            'price_range',
            'minimum_price',
            'final_price',
            'currency'
        ],
        product_type: ['__typename'],
        category: ['category', 'name']
    }
}
